{
  "timeOff.title": "Time off",
  "timeOff.hub.label": "Time off views",
  "timeOff.hub.whosOut": "Who's out",
  "timeOff.hub.requests": "Requests",
  "timeOff.hub.overtime": "Overtime",
  "timeOff.hub.balances": "Balances",
  "timeOff.hub.types": "Leave types",
  "timeOff.hub.holidays": "Public holidays",
  "timeOff.days.count": "{count, plural, one {# day} other {# days}}",
  "timeOff.days.half": "half a day",
  "timeOff.range.span": "{start} – {end}",
  "timeOff.range.half": "{date} · {label}",
  "timeOff.halfDay.none": "full day",
  "timeOff.halfDay.first_half": "morning",
  "timeOff.halfDay.second_half": "afternoon",
  "timeOff.halfDay.choice.none": "Full day",
  "timeOff.halfDay.choice.first_half": "Morning",
  "timeOff.halfDay.choice.second_half": "Afternoon",
  "timeOff.status.pending": "Waiting",
  "timeOff.status.approved": "Approved",
  "timeOff.status.rejected": "Rejected",
  "timeOff.status.cancelled": "Withdrawn by the employee",
  "timeOff.status.revoked": "Revoked after approval",
  "timeOff.balance.grantedSplit": "{earned} earned in {year} so far + {carried} carried over or added",
  "timeOff.filters.status": "Filter by status",
  "timeOff.filters.statuses.all": "All",
  "timeOff.filters.statuses.pending": "Waiting",
  "timeOff.filters.statuses.approved": "Approved",
  "timeOff.filters.statuses.rejected": "Rejected",
  "timeOff.filters.statuses.revoked": "Revoked after approval",
  "timeOff.filters.statuses.cancelled": "Withdrawn by the employee",
  "timeOff.filters.month": "Month",
  "timeOff.filters.anyMonth": "Any month",
  "timeOff.filters.type": "Leave type",
  "timeOff.filters.anyType": "Any leave type",
  "timeOff.filters.person": "Person",
  "timeOff.filters.anyone": "Everyone",
  "timeOff.filters.searchPeople": "Search people",
  "timeOff.filters.noPeople": "No one matches.",
  "timeOff.filters.clear": "Clear filters",
  "timeOff.calendar.out": "Out",
  "timeOff.calendar.someone": "Someone",
  "timeOff.calendar.separator": ", ",
  "timeOff.calendar.entrySeparator": "; ",
  "timeOff.calendar.today": "Today",
  "timeOff.calendar.holiday": "Public holiday: {name}",
  "timeOff.calendar.nobodyOut": "Nobody is out",
  "timeOff.calendar.outList": "{count, plural, one {# person out} other {# people out}}: {list}",
  "timeOff.calendar.outCount": "{count, plural, one {# person out} other {# people out}}",
  "timeOff.calendar.more": "+{count} more",
  "timeOff.calendar.everyoneIn": "Everyone is in.",
  "timeOff.calendar.weekend": "Weekend.",
  "timeOff.calendar.holidayEveryone": "A public holiday: the whole team is off.",
  "timeOff.calendar.previousMonth": "Previous month",
  "timeOff.calendar.nextMonth": "Next month",
  "timeOff.calendar.previousWeek": "Previous week",
  "timeOff.calendar.nextWeek": "Next week",
  "timeOff.calendar.weekLabel": "The week, day by day",
  "timeOff.calendar.legend": "What the colours mean",
  "timeOff.calendar.legendPending": "Waiting for approval",
  "timeOff.calendar.legendHalf": "Half day",
  "timeOff.calendar.legendHoliday": "Public holiday",
  "timeOff.calendar.loadError": "We couldn't load who's out.",
  "timeOff.calendar.holidaysError": "Public holidays couldn't be loaded, so they aren't marked.",
  "timeOff.requests.caption": "Leave requests",
  "timeOff.requests.columns.person": "Person",
  "timeOff.requests.columns.kind": "Leave type",
  "timeOff.requests.columns.dates": "Days",
  "timeOff.requests.columns.status": "Status",
  "timeOff.requests.columns.requested": "Requested",
  "timeOff.requests.workingDays": "Working days: {days}",
  "timeOff.requests.open": "Open {name}'s request",
  "timeOff.requests.hasDocument": "Has a document",
  "timeOff.requests.sheetTitle": "Leave request",
  "timeOff.requests.note": "Note",
  "timeOff.requests.document": "Document",
  "timeOff.requests.documentMissing": "Missing: needed before approval",
  "timeOff.requests.documentNone": "None",
  "timeOff.requests.inboxHint": "Managers and HR usually decide in the Requests inbox.",
  "timeOff.requests.inboxLink": "Open Requests",
  "timeOff.requests.loadError": "We couldn't load the leave requests.",
  "timeOff.requests.empty.title": "No leave requests yet",
  "timeOff.requests.empty.body": "Requests appear here as soon as someone asks for time off.",
  "timeOff.requests.noMatch.title": "Nothing matches these filters",
  "timeOff.requests.noMatch.body": "Try another month, status or person, or clear the filters.",
  "timeOff.decide.approve": "Approve",
  "timeOff.decide.approving": "Approving…",
  "timeOff.decide.approved": "{name}'s request approved.",
  "timeOff.decide.reject": "Reject",
  "timeOff.decide.rejectTitle": "Reject {name}'s request?",
  "timeOff.decide.rejectBody": "They'll see your reason with the decision.",
  "timeOff.decide.rejectReason": "Why are you rejecting it?",
  "timeOff.decide.rejected": "{name}'s request rejected.",
  "timeOff.revoke.open": "Revoke",
  "timeOff.revoke.title": "Revoke {name}'s leave?",
  "timeOff.revoke.body": "The leave is cancelled and its {days} go back to the balance. Your reason stays in their history.",
  "timeOff.revoke.confirm": "Revoke leave",
  "timeOff.revoke.done": "{name}'s leave was revoked.",
  "timeOff.revoke.revokedTitle": "Revoked by HR",
  "timeOff.flow.title": "Approval",
  "timeOff.flow.label": "Approval steps",
  "timeOff.flow.requested": "Requested",
  "timeOff.flow.requestedBy": "Requested by {name}",
  "timeOff.flow.approvedBy": "Approved by {name}",
  "timeOff.flow.rejectedBy": "Rejected by {name}",
  "timeOff.flow.waitingFor": "Waiting for {name}",
  "timeOff.flow.then": "Then {name}",
  "timeOff.flow.skipped": "{name}: skipped",
  "timeOff.flow.hr": "HR",
  "timeOff.flow.manager": "Their manager",
  "timeOff.flow.withdrawn": "Withdrawn",
  "timeOff.flow.revoked": "Revoked by HR",
  "timeOff.overtime.caption": "Overtime records",
  "timeOff.overtime.columns.when": "When",
  "timeOff.overtime.columns.split": "Day and night",
  "timeOff.overtime.columns.kind": "Day",
  "timeOff.overtime.columns.paidAs": "Paid as",
  "timeOff.overtime.columns.reason": "Reason",
  "timeOff.overtime.open": "Open {name}'s overtime",
  "timeOff.overtime.sheetTitle": "Overtime",
  "timeOff.overtime.dayPart": "Daytime {duration}",
  "timeOff.overtime.nightPart": "Night {duration}",
  "timeOff.overtime.loadError": "We couldn't load overtime.",
  "timeOff.overtime.empty.title": "No overtime yet",
  "timeOff.overtime.empty.body": "Overtime appears here once someone records it.",
  "timeOff.overtime.errors.day": "Choose the day.",
  "timeOff.overtime.errors.start": "Enter when you started.",
  "timeOff.overtime.errors.end": "Enter when you finished.",
  "timeOff.overtime.errors.span": "Overtime runs from a minute to 16 hours.",
  "timeOff.overtime.errors.reason": "Write a reason of at least 3 characters.",
  "timeOff.dayKind.workday": "Working day",
  "timeOff.dayKind.rest_day": "Rest day",
  "timeOff.dayKind.holiday": "Public holiday",
  "timeOff.compensation.pay": "Paid",
  "timeOff.compensation.day_off": "Day off instead",
  "timeOff.pay.title": "How it's paid",
  "timeOff.pay.label": "How this overtime is paid",
  "timeOff.pay.rate": "×{rate}",
  "timeOff.pay.rateMinimum": "×{rate} or more",
  "timeOff.pay.day": "Daytime hours ({duration}) paid at {rate} the hourly overtime wage",
  "timeOff.pay.night": "Night hours ({duration}), sunset to sunrise, paid at {rate} the hourly overtime wage",
  "timeOff.pay.restDay": "{days, plural, one {A day's wage} other {# days' wages}} for working a rest day",
  "timeOff.pay.substituteDay": "Plus a substitute day off, added to the compensatory balance",
  "timeOff.pay.holiday": "{days, plural, =2 {Twice a day's wage} one {A day's wage} other {# days' wages}} for working a public holiday",
  "timeOff.pay.holidayDayOff": "A day off instead of pay (as asked in writing), added to the compensatory balance",
  "timeOff.balance.caption": "Balances in {year}",
  "timeOff.balance.meter": "{used} used and {pending} waiting, of {total}",
  "timeOff.balance.granted": "Granted",
  "timeOff.balance.taken": "Taken",
  "timeOff.balance.removed": "Expired or removed",
  "timeOff.balance.pending": "Waiting",
  "timeOff.balance.available": "Left",
  "timeOff.balances.title": "Balances in {year}",
  "timeOff.balances.description": "What everyone has left of each leave type with its own balance. Casual leave comes out of annual leave.",
  "timeOff.balances.caption": "Everyone's leave balances in {year}",
  "timeOff.balances.of": "left of {total}",
  "timeOff.balances.cellError": "Couldn't load",
  "timeOff.balances.nothing": "No balance",
  "timeOff.balances.loadError": "We couldn't load the balances.",
  "timeOff.balances.empty.title": "No HR records yet",
  "timeOff.balances.empty.body": "Balances appear once people have HR records.",
  "timeOff.accrual.open": "Grant the year's balances",
  "timeOff.accrual.title": "Grant the {year} allowances?",
  "timeOff.accrual.body": "Everyone with an HR record gets {year}'s days for each leave type with its own balance. Last year's unused days carry over up to each type's limit; the rest expires.",
  "timeOff.accrual.safe": "It's safe to run more than once: anyone who already has their {year} days is skipped, so nobody is granted twice.",
  "timeOff.accrual.confirm": "Grant allowances",
  "timeOff.accrual.running": "Granting…",
  "timeOff.accrual.done": "{count, plural, one {# allowance granted.} other {# allowances granted.}}",
  "timeOff.accrual.nothing": "Everyone already had their {year} days. Nothing changed.",
  "timeOff.types.title": "Leave types",
  "timeOff.types.description": "The kinds of leave people can ask for, their pay and balance, and their rules.",
  "timeOff.types.add": "Add a leave type",
  "timeOff.types.caption": "Leave types and their rules",
  "timeOff.types.columns.kind": "Leave type",
  "timeOff.types.columns.paid": "Pay",
  "timeOff.types.columns.days": "Days a year",
  "timeOff.types.columns.rules": "Rules",
  "timeOff.types.columns.status": "Status",
  "timeOff.types.columns.actions": "Actions",
  "timeOff.types.paidYes": "Paid",
  "timeOff.types.paidNo": "Unpaid",
  "timeOff.types.noBalance": "No balance",
  "timeOff.types.fromBalance": "From the {name} balance",
  "timeOff.types.firstYear": "{days} in the first year",
  "timeOff.types.senior": "{days} after {years, plural, one {# year} other {# years}}",
  "timeOff.types.cap": "Up to {days} a year",
  "timeOff.types.carries": "Carries over up to {days}",
  "timeOff.types.halfDays": "Half days",
  "timeOff.types.needsDocument": "Needs a document",
  "timeOff.types.encashed": "Paid out on exit",
  "timeOff.types.retired": "Retired",
  "timeOff.types.offered": "Offered",
  "timeOff.types.edit": "Edit {name}",
  "timeOff.types.editShort": "Edit",
  "timeOff.types.newTitle": "New leave type",
  "timeOff.types.editTitle": "Edit {name}",
  "timeOff.types.save": "Save leave type",
  "timeOff.types.saving": "Saving…",
  "timeOff.types.saved": "{name} saved.",
  "timeOff.types.created": "{name} added.",
  "timeOff.types.loadError": "We couldn't load the leave types.",
  "timeOff.types.empty.title": "No leave types yet",
  "timeOff.types.empty.body": "Add the kinds of leave people can ask for, such as annual and sick leave.",
  "timeOff.types.sections.identity": "Name and look",
  "timeOff.types.sections.balance": "Pay and balance",
  "timeOff.types.sections.rules": "Rules",
  "timeOff.types.sections.law": "Under the labour law",
  "timeOff.types.law.category": "Kind under the law",
  "timeOff.types.law.categoryHint": "Annual leave accrues monthly; casual leave draws from it.",
  "timeOff.types.law.gender": "Who may take it",
  "timeOff.types.law.genderAny": "Anyone",
  "timeOff.types.law.genderFemale": "Women",
  "timeOff.types.law.genderMale": "Men",
  "timeOff.types.law.payPercent": "Pay kept (%)",
  "timeOff.types.law.payPercentHint": "100 for full pay; sick leave follows social insurance (e.g. 75).",
  "timeOff.types.law.perRequest": "Longest single request (days)",
  "timeOff.types.law.perRequestHint": "Casual leave is 2 days at a time (Art. 128). Empty for no limit.",
  "timeOff.types.law.timesInService": "Times in someone's service",
  "timeOff.types.law.timesInServiceHint": "Maternity and paternity: 3; Hajj: once. Empty for no limit.",
  "timeOff.types.law.minService": "Service needed (months)",
  "timeOff.types.law.minServiceHint": "Hajj needs 60 months; childcare 12.",
  "timeOff.types.law.minGap": "Gap between two (months)",
  "timeOff.types.law.minGapHint": "Childcare: 24 months between two leaves (Art. 57).",
  "timeOff.types.law.minHeadcount": "Staff size needed",
  "timeOff.types.law.minHeadcountHint": "Childcare applies with 50 or more workers (Art. 57).",
  "timeOff.types.law.calendarDays": "Count calendar days",
  "timeOff.types.law.calendarDaysHint": "Maternity and childcare count every day, not working days only.",
  "timeOff.types.category.annual": "Annual",
  "timeOff.types.category.casual": "Casual",
  "timeOff.types.category.sick": "Sick",
  "timeOff.types.category.maternity": "Maternity",
  "timeOff.types.category.paternity": "Paternity",
  "timeOff.types.category.childcare": "Childcare",
  "timeOff.types.category.study": "Study or exams",
  "timeOff.types.category.religious": "Hajj or Jerusalem",
  "timeOff.types.category.unpaid": "Unpaid",
  "timeOff.types.category.compensatory": "Compensatory",
  "timeOff.types.category.company": "Company policy",
  "timeOff.types.errors.percent": "Enter a percentage from 0 to 100.",
  "timeOff.types.errors.whole": "Enter a whole number in range, or leave it empty.",
  "timeOff.types.fields.nameAr": "Arabic name",
  "timeOff.types.fields.nameEn": "English name",
  "timeOff.types.fields.code": "Code",
  "timeOff.types.fields.codeHint": "Lower-case letters, digits and _ (such as annual). Reports use it.",
  "timeOff.types.fields.position": "Order",
  "timeOff.types.fields.positionHint": "Lower numbers come first in lists (0 to 100).",
  "timeOff.types.fields.color": "Colour on the calendar",
  "timeOff.types.fields.paid": "Paid",
  "timeOff.types.fields.paidHint": "Paid at the share set in Pay percent. Unpaid leave costs a day's wage for each day.",
  "timeOff.types.fields.deducts": "Counts against a balance",
  "timeOff.types.fields.deductsHint": "Each day taken comes out of a yearly balance. Sick leave usually doesn't.",
  "timeOff.types.fields.balance": "Balance",
  "timeOff.types.fields.balanceHint": "Casual leave, for example, comes out of the annual leave balance.",
  "timeOff.types.fields.ownBalance": "Its own balance",
  "timeOff.types.fields.fromBalance": "The {name} balance",
  "timeOff.types.fields.annualDays": "Days a year",
  "timeOff.types.fields.annualDaysHint": "Granted at the start of each year by the yearly accrual.",
  "timeOff.types.fields.firstYearDays": "In the first year",
  "timeOff.types.fields.firstYearDaysHint": "Before a full year of service. Empty: the usual days.",
  "timeOff.types.fields.seniorDays": "After long service",
  "timeOff.types.fields.seniorDaysHint": "Days a year once someone has served long enough.",
  "timeOff.types.fields.seniorAfterYears": "Long service starts after (years)",
  "timeOff.types.fields.carryOver": "Carry over up to",
  "timeOff.types.fields.carryOverHint": "Unused days that move to next year; the rest expires. Empty: none.",
  "timeOff.types.fields.yearlyCap": "Most days a year",
  "timeOff.types.fields.yearlyCapHint": "A limit on days taken in a year, even with balance left. Empty: no limit.",
  "timeOff.types.fields.halfDay": "Half days allowed",
  "timeOff.types.fields.halfDayHint": "People can ask for the first or the second half of a day.",
  "timeOff.types.fields.attachment": "Needs a document",
  "timeOff.types.fields.attachmentHint": "Such as a medical certificate. HR can't approve without it.",
  "timeOff.types.fields.encash": "Paid out on exit",
  "timeOff.types.fields.encashHint": "When someone leaves, their unused days of this type are paid at their day value in their final settlement.",
  "timeOff.types.fields.active": "Offered",
  "timeOff.types.fields.activeHint": "Untick to retire it: past leave stays in the history, but nobody can ask for it.",
  "timeOff.types.errors.code": "Use 2 to 30 lower-case letters, digits or _, starting with a letter.",
  "timeOff.types.errors.required": "Fill this in.",
  "timeOff.types.errors.days": "Enter days from 0 to 365, with up to two decimals.",
  "timeOff.types.errors.positive": "Enter more than 0, or leave it empty.",
  "timeOff.types.errors.years": "Enter whole years from 1 to 50.",
  "timeOff.types.errors.seniority": "Fill in both the long-service days and the years, or neither.",
  "timeOff.types.errors.position": "Enter a whole number from 0 to 100.",
  "timeOff.colors.sage": "Sage",
  "timeOff.colors.sky": "Sky",
  "timeOff.colors.sand": "Sand",
  "timeOff.colors.rose": "Rose",
  "timeOff.colors.lilac": "Lilac",
  "timeOff.colors.teal": "Teal",
  "timeOff.colors.slate": "Slate",
  "timeOff.holidays.title": "Public holidays in {year}",
  "timeOff.holidays.description": "Nobody is expected at work on these days, and leave doesn't count them.",
  "timeOff.holidays.add": "Add a holiday",
  "timeOff.holidays.addTitle": "Add a public holiday",
  "timeOff.holidays.editTitle": "Edit the holiday",
  "timeOff.holidays.dialogBody": "Its day and its name in both languages.",
  "timeOff.holidays.save": "Save holiday",
  "timeOff.holidays.added": "Holiday added.",
  "timeOff.holidays.saved": "Holiday saved.",
  "timeOff.holidays.fields.day": "Day",
  "timeOff.holidays.fields.nameAr": "Arabic name",
  "timeOff.holidays.fields.nameEn": "English name",
  "timeOff.holidays.errors.day": "Choose the day.",
  "timeOff.holidays.errors.name": "Write its name.",
  "timeOff.holidays.next": "Next",
  "timeOff.holidays.edit": "Edit {name}",
  "timeOff.holidays.remove": "Remove {name}",
  "timeOff.holidays.removeTitle": "Remove {name}?",
  "timeOff.holidays.removeBody": "The day becomes a normal working day for attendance and leave.",
  "timeOff.holidays.removeConfirm": "Remove holiday",
  "timeOff.holidays.removed": "{name} removed.",
  "timeOff.holidays.loadError": "We couldn't load the holidays.",
  "timeOff.holidays.empty.title": "No holidays in {year} yet",
  "timeOff.holidays.empty.body": "Add the year's public holidays so attendance and leave skip them.",
  "timeOff.holidays.empty.bodyReadOnly": "HR adds the year's public holidays here.",
  "timeOff.year.label": "Year",
  "timeOff.year.previous": "Previous year",
  "timeOff.year.next": "Next year",
  "timeOff.year.value": "{year}",
  "timeOff.ledger.caption": "Balance history in {year}",
  "timeOff.ledger.columns.when": "Date",
  "timeOff.ledger.columns.what": "Change",
  "timeOff.ledger.columns.change": "Days",
  "timeOff.ledger.columns.by": "By",
  "timeOff.ledger.automatic": "Automatic",
  "timeOff.ledger.kind.grant": "Yearly allowance",
  "timeOff.ledger.auto.grant": "Granted by the yearly accrual.",
  "timeOff.ledger.kind.request": "Leave taken",
  "timeOff.ledger.auto.request": "Approved leave.",
  "timeOff.ledger.kind.reversal": "Leave returned",
  "timeOff.ledger.auto.reversal": "Revoked leave; its days came back.",
  "timeOff.ledger.kind.adjustment": "Adjusted by hand",
  "timeOff.ledger.auto.adjustment": "Changed by hand.",
  "timeOff.ledger.kind.carry_over": "Carried over",
  "timeOff.ledger.auto.carry_over": "Unused days brought from last year.",
  "timeOff.ledger.kind.expiry": "Expired",
  "timeOff.ledger.auto.expiry": "Unused days that ran out at year end.",
  "timeOff.ledger.kind.compensatory": "Compensatory day",
  "timeOff.ledger.auto.compensatory": "Earned by working a rest day or a public holiday.",
  "timeOff.ledger.kind.advance": "Advance",
  "timeOff.ledger.auto.advance": "Leave HR allowed before it was earned.",
  "timeOff.ledger.kind.settlement": "Settled",
  "timeOff.ledger.auto.settlement": "Days paid out or agreed off, with HR's reason.",
  "timeOff.profile.title": "Time off",
  "timeOff.profile.description": "{name}'s balances and every change to them, with who made it and why.",
  "timeOff.profile.balances": "Balances in {year}",
  "timeOff.profile.history": "History in {year}",
  "timeOff.profile.requestsLink": "Their leave requests",
  "timeOff.profile.loadError": "We couldn't load this time off.",
  "timeOff.profile.noBalances.title": "No balances in {year}",
  "timeOff.profile.noBalances.body": "Run the yearly accrual from Time off › Balances, or adjust a balance by hand.",
  "timeOff.profile.noBalances.bodyReadOnly": "HR grants the year's days with the yearly accrual.",
  "timeOff.profile.noHistory.title": "Nothing moved yet",
  "timeOff.profile.noHistory.body": "Grants, leave and adjustments in {year} appear here.",
  "timeOff.adjust.open": "Adjust balance",
  "timeOff.adjust.compensatoryOpen": "Credit a compensatory day",
  "timeOff.adjust.title": "Adjust {name}'s balance",
  "timeOff.adjust.body": "Add or remove days for {year}. The change and your reason stay in their history.",
  "timeOff.adjust.compensatoryTitle": "Credit {name} a compensatory day",
  "timeOff.adjust.compensatoryBody": "A day off owed for working a rest day or a public holiday, added to their {year} compensatory balance.",
  "timeOff.adjust.kind": "Balance",
  "timeOff.adjust.direction": "Change",
  "timeOff.adjust.add": "Add days",
  "timeOff.adjust.remove": "Remove days",
  "timeOff.adjust.amount": "Days",
  "timeOff.adjust.amountHint": "Half days as 0.5.",
  "timeOff.adjust.preview": "{name} left:",
  "timeOff.adjust.reason": "Reason",
  "timeOff.adjust.reasonHint": "Kept in their history, such as \"Worked Friday 10 Oct for the launch\".",
  "timeOff.adjust.save": "Save adjustment",
  "timeOff.adjust.credit": "Credit the day",
  "timeOff.adjust.saved": "{name}'s balance adjusted.",
  "timeOff.adjust.credited": "Compensatory day credited to {name}.",
  "timeOff.adjust.errors.type": "Choose a balance.",
  "timeOff.adjust.errors.amount": "Enter days from 0.5 to 365, with up to two decimals.",
  "timeOff.adjust.errors.reason": "Write a reason of at least 3 characters.",
  "timeOff.mine.title": "My time off",
  "timeOff.mine.description": "Your balances, your leave requests and your overtime.",
  "timeOff.mine.balances": "Balances in {year}",
  "timeOff.mine.balancesError": "We couldn't load your balances.",
  "timeOff.mine.daysLeft": "{count, plural, one {day left} other {days left}}",
  "timeOff.mine.figures": "{used} taken · {pending} waiting · of {total}",
  "timeOff.mine.accrued": "{days} earned so far this year, a month at a time",
  "timeOff.mine.usableFrom": "Earned days can be used from {date}, after six months of service",
  "timeOff.mine.shared": "{list} also comes out of this balance.",
  "timeOff.mine.noBalances.title": "No balances in {year} yet",
  "timeOff.mine.noBalances.body": "HR grants each year's days at the start of the year.",
  "timeOff.mine.viewLabel": "Show",
  "timeOff.mine.leaveTab": "Leave requests",
  "timeOff.mine.overtimeTab": "Overtime",
  "timeOff.mine.requestsError": "We couldn't load your requests.",
  "timeOff.mine.overtimeError": "We couldn't load your overtime.",
  "timeOff.mine.noRequests.title": "No leave requests yet",
  "timeOff.mine.noRequests.body": "Ask for time off and follow it here as your manager and HR decide.",
  "timeOff.mine.noOvertime.title": "No overtime yet",
  "timeOff.mine.noOvertime.body": "Record overtime after you work it: your manager and HR approve it, and payroll pays it.",
  "timeOff.mine.requestFacts": "{days} · requested {date}",
  "timeOff.mine.revokedBecause": "HR revoked this leave:",
  "timeOff.mine.documentNeeded": "This leave needs a document before it can be approved.",
  "timeOff.mine.progress": "Progress",
  "timeOff.mine.openDocument": "Open document",
  "timeOff.mine.withdraw": "Withdraw",
  "timeOff.mine.keep": "Keep it",
  "timeOff.mine.withdrawTitle": "Withdraw this request?",
  "timeOff.mine.withdrawBody": "Your request for {date} is cancelled, and nobody needs to decide it.",
  "timeOff.mine.withdrawn": "Request withdrawn.",
  "timeOff.mine.withdrawOvertimeTitle": "Withdraw this overtime?",
  "timeOff.mine.withdrawOvertimeBody": "Your overtime on {date} is cancelled before anyone decides it.",
  "timeOff.mine.overtimeWithdrawn": "Overtime withdrawn.",
  "timeOff.mine.noRecord.title": "Your time off appears once HR opens your record",
  "timeOff.mine.noRecord.body": "HR keeps a record for each member of the team. When yours is ready, your balances and requests show here.",
  "timeOff.request.open": "Request leave",
  "timeOff.request.title": "Request leave",
  "timeOff.request.description": "It goes to your manager first, then to HR.",
  "timeOff.request.kind": "Leave type",
  "timeOff.request.kindLeft": "{left} left",
  "timeOff.request.kindShared": "From your {name} balance",
  "timeOff.request.kindFree": "No balance needed",
  "timeOff.request.kindUnpaid": "Costs a day's wage for each day",
  "timeOff.request.kindDocument": "Needs a document",
  "timeOff.request.from": "First day",
  "timeOff.request.to": "Last day",
  "timeOff.request.length": "How long",
  "timeOff.request.document": "Document",
  "timeOff.request.documentHint": "Such as a medical certificate. HR can't approve without it.",
  "timeOff.request.note": "Note",
  "timeOff.request.noteHint": "Optional. What your manager should know.",
  "timeOff.request.send": "Send request",
  "timeOff.request.sending": "Sending…",
  "timeOff.request.sent": "Leave requested. Your manager will see it first.",
  "timeOff.request.sentWithoutDocument": "Your request was sent, but the document didn't upload. Attach it from your requests.",
  "timeOff.request.noKinds": "There are no leave types to ask for yet. HR adds them.",
  "timeOff.request.errors.type": "Choose a leave type.",
  "timeOff.request.errors.start": "Choose the first day.",
  "timeOff.request.errors.end": "Choose the last day.",
  "timeOff.request.errors.order": "The last day comes after the first.",
  "timeOff.request.errors.oneYear": "Ask for each calendar year separately.",
  "timeOff.request.errors.halfNotAllowed": "This leave type is taken in full days.",
  "timeOff.request.errors.halfSingleDay": "Half a day is for a single day.",
  "timeOff.request.errors.attachment": "Attach the document this leave needs.",
  "timeOff.estimate.days": "About {days}",
  "timeOff.estimate.leaves": "Leaves {left} of your {name} balance.",
  "timeOff.estimate.short": "More than the {left} left in your {name} balance.",
  "timeOff.estimate.note": "An estimate: rest days and public holidays don't count. We count again when you send it.",
  "timeOff.estimate.noteAgencyWeek": "An estimate counting Sunday to Thursday as working days, since your weekly plan couldn't be read. We count again when you send it.",
  "timeOff.estimate.problem.order": "The last day comes before the first.",
  "timeOff.estimate.problem.years": "Leave runs within one calendar year; ask for each year separately.",
  "timeOff.estimate.problem.halfRange": "Half a day is for a single day.",
  "timeOff.estimate.problem.halfOff": "That day is a rest day or a holiday, so it costs nothing.",
  "timeOff.estimate.problem.noWorkingDays": "These are all rest days or holidays, so there's nothing to ask for.",
  "timeOff.record.open": "Record overtime",
  "timeOff.record.title": "Record overtime",
  "timeOff.record.description": "Your manager, then HR, approve it; payroll pays it.",
  "timeOff.record.day": "Day",
  "timeOff.record.start": "From",
  "timeOff.record.end": "To",
  "timeOff.record.total": "{duration} of overtime",
  "timeOff.record.nextDay": "(ends the next day)",
  "timeOff.record.kindUnknown": "We'll know the kind of day once you send it.",
  "timeOff.record.ruleDay": "Daytime hours paid at {rate} the hourly overtime wage",
  "timeOff.record.ruleNight": "Night hours (sunset to sunrise) paid at {rate} the hourly overtime wage",
  "timeOff.record.compensation": "How do you want it?",
  "timeOff.record.pay": "Get paid",
  "timeOff.record.payHint": "The holiday wage: twice a day's pay by law.",
  "timeOff.record.dayOff": "A day off instead",
  "timeOff.record.dayOffHint": "Choosing this is your written request for a substitute day.",
  "timeOff.record.reason": "Reason",
  "timeOff.record.reasonHint": "What you worked on, for your manager.",
  "timeOff.record.send": "Send for approval",
  "timeOff.record.sending": "Sending…",
  "timeOff.record.sent": "Overtime sent for approval.",
  "timeOff.attach.open": "Attach document",
  "timeOff.attach.title": "Attach a document",
  "timeOff.attach.body": "A PDF or a photo, up to 10 MB. HR sees it with your request.",
  "timeOff.attach.send": "Attach",
  "timeOff.attach.sending": "Uploading…",
  "timeOff.attach.done": "Document attached.",
  "timeOff.errors.typeNotFound": "That leave type no longer exists.",
  "timeOff.errors.codeTaken": "Another leave type already uses this code.",
  "timeOff.errors.requestNotFound": "We couldn't find that request.",
  "timeOff.errors.overlap": "You already asked for leave on some of those days.",
  "timeOff.errors.invalid": "Choose working days within one year; half a day is for a single day.",
  "timeOff.errors.balance": "Not enough balance left for that leave.",
  "timeOff.errors.attachmentRequired": "This leave needs its document before it can be approved.",
  "timeOff.errors.notEligible": "This kind of leave doesn't apply to you yet.",
  "timeOff.errors.tooLongForKind": "That's more days than this kind of leave allows at one time.",
  "timeOff.errors.timesUsed": "This kind of leave has been taken as many times as the law allows.",
  "timeOff.errors.belowLaw": "The law grants more than this. A policy can only be more generous.",
  "timeOff.errors.attachmentType": "Attach a PDF, PNG, JPEG or WebP up to 10 MB.",
  "timeOff.errors.overtimeNotFound": "We couldn't find that overtime.",
  "timeOff.errors.overtimeInvalid": "Overtime runs for up to 16 hours, within 60 days of today.",
  "timeOff.errors.holidayExists": "That day is already a holiday.",
  "timeOff.errors.holidayNotFound": "We couldn't find that holiday.",
  "timeOff.errors.periodLocked": "That month is locked for payroll.",
  "timeOff.errors.periodFinal": "That month's attendance is final. HR must reopen it first.",
  "timeOff.errors.noRecord": "There's no HR record for this person yet.",
  "timeOff.errors.requestClosed": "This request was already decided or withdrawn.",
  "timeOff.errors.notYourDecision": "This step isn't yours to decide.",
  "timeOff.errors.tooLong": "That's too long."
}
